import { shouldAnimate } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateNewsletter } from '@/js/global/animations'


register("newsletter", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateNewsletter = animateNewsletter(this.container);
    }
  },
  onUnload() {
    var _this$animateNewslett;
    (_this$animateNewslett = this.animateNewsletter) === null || _this$animateNewslett === void 0 ? void 0 : _this$animateNewslett.destroy();
  }
});
